import {
  EMPTY_LABEL_ERROR,
  EMPTY_TITLE_ERROR,
  MAX_DESCRIPTION_LENGTH,
  MAX_LABELS,
  MAX_TITLE_LENGTH,
} from '@/components/challenge/CompanyChallengeManagement/constants';
import * as Yup from 'yup';

export const CompanyChallengeSchema = Yup.object().shape({
  title: Yup.string().required(EMPTY_TITLE_ERROR).max(MAX_TITLE_LENGTH),
  description: Yup.string().max(MAX_DESCRIPTION_LENGTH),
  labels: Yup.array()
    .of(
      Yup.object().shape({
        index: Yup.number().required(),
        label: Yup.string()
          .required(EMPTY_LABEL_ERROR)
          // `.required()` alone treats a whitespace-only string as present —
          // without this test a blank-looking label passes Yup validation
          // (Save stays enabled) even though it renders a red error, since
          // the error shown was being recomputed manually from `!trim()`
          // rather than sourced from Yup at all.
          .test('not-blank', EMPTY_LABEL_ERROR, (value) =>
            Boolean(value?.trim())
          ),
      })
    )
    .min(1)
    .max(MAX_LABELS),
});
